import React, { useEffect, useState } from 'react';
import api from '../api';
import { Ban, RefreshCw, ExternalLink, CheckCircle2, AlertOctagon, HelpCircle } from 'lucide-react';

const STATUS = {
  clean:   { label: 'Limpo',            cls: 'ok',   icon: CheckCircle2 },
  listed:  { label: 'LISTADO',          cls: 'err',  icon: AlertOctagon },
  unknown: { label: 'Verificar no site',cls: 'warn', icon: HelpCircle },
  na:      { label: '—',                cls: '',     icon: null },
};

export default function Blacklist() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const load = async () => {
    setLoading(true); setErr('');
    try { const r = await api.get('/blacklist/check'); setData(r.data); }
    catch (e) { setErr(e.response?.data?.error || 'Erro ao consultar blacklists'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const totalListed = (data?.ips || []).reduce((a, i) => a + (i.listed || 0), 0);

  return (
    <>
      <div className="page-title">
        <h1><Ban size={20} style={{ verticalAlign: 'middle' }} /> Blacklist / Reputação dos IPs</h1>
        <button onClick={load} className="ghost" disabled={loading}>
          <RefreshCw size={14} /> {loading ? 'Verificando…' : 'Verificar agora'}
        </button>
      </div>

      <p style={{ color: '#a1a1aa', fontSize: '.88rem', maxWidth: '900px' }}>
        Consulta os <strong>3 IPs IPv4 e os 3 IPv6</strong> usados pelo servidor (NS1, NS2 e Serviços/Mail) nas principais
        listas de bloqueio. <strong>LISTADO</strong> = pedir desbloqueio no link. <strong>Verificar no site</strong> = a lista
        (ex.: Spamhaus) não responde por DNS público — confira pelo botão.
      </p>

      {err && <div className="err-msg" style={{ marginTop: '1rem' }}>{err}</div>}
      {!data && !err && <p style={{ color: '#a1a1aa', marginTop: '1rem' }}>Consultando…</p>}

      {data && (
        <>
          <div style={{ margin: '1rem 0', padding: '.8rem 1rem', borderRadius: '8px',
            background: totalListed ? 'rgba(239,68,68,.12)' : 'rgba(16,185,129,.12)',
            border: '1px solid ' + (totalListed ? '#7f1d1d' : '#065f46'), fontSize: '.9rem' }}>
            {totalListed
              ? <span style={{ color: '#f87171' }}><AlertOctagon size={14} style={{ verticalAlign: 'middle' }} /> <strong>{totalListed}</strong> listagem(ns) encontrada(s) — peça o desbloqueio nos links abaixo.</span>
              : <span style={{ color: '#34d399' }}><CheckCircle2 size={14} style={{ verticalAlign: 'middle' }} /> Nenhuma listagem confirmada por DNS (veja as marcadas "Verificar no site").</span>}
            <span style={{ color: '#71717a', marginLeft: '.6rem' }}>Verificado: {data.checked_at ? new Date(data.checked_at).toLocaleString('pt-BR') : '—'}</span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '.8rem' }}>
            {data.ips.map((it, idx) => (
              <div key={idx} className="card" style={{ padding: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.6rem' }}>
                  <div>
                    <strong style={{ fontFamily: 'JetBrains Mono', fontSize: '1rem', color: '#3b82f6' }}>{it.ip}</strong>
                    <span style={{ marginLeft: '.6rem', color: '#a1a1aa', fontSize: '.82rem' }}>{it.label} · {it.family.toUpperCase()}</span>
                  </div>
                  <span className={'badge ' + (it.listed ? 'err' : 'ok')}>{it.listed ? `${it.listed} listado(s)` : 'OK'}</span>
                </div>
                <table>
                  <thead><tr><th>Lista de bloqueio</th><th>Status</th><th>Ação</th></tr></thead>
                  <tbody>
                    {it.lists.map(l => {
                      const st = STATUS[l.status] || STATUS.na;
                      const Icon = st.icon;
                      return (
                        <tr key={l.id}>
                          <td>{l.name}</td>
                          <td>
                            {l.status === 'na'
                              ? <span style={{ color: '#52525b' }}>—</span>
                              : <span className={'badge ' + st.cls}>{Icon && <Icon size={11} style={{ verticalAlign: 'middle' }} />} {st.label}</span>}
                          </td>
                          <td>
                            {(l.status === 'listed' || l.status === 'unknown')
                              ? <a href={l.delist} target="_blank" rel="noreferrer" style={{ color: '#3b82f6' }}>Desbloquear <ExternalLink size={10} /></a>
                              : <span style={{ color: '#52525b' }}>—</span>}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
